import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  dropdown: {
    width: "239px !important",
  },
}));
